import { PropsOf } from '../../../types';
import AddVideoForm, { dataFactory, VideoScaling } from './AddVideoForm';
import connect from './connect';

export default connect(AddVideoForm);

export type AddVideoFormProps = PropsOf<ReturnType<typeof connect>>;
export { dataFactory, VideoScaling };
